/*
	CHIPSAJ v0.001Swiper
	Last update 03/01/2024
*/
import swiperSlideshow from "./components/swiperSlideshow.js";
const CHIPSAJ = {
	constructor() {},
	init() {
		let appScope = this;
		this.ajaxMode = true; // false won't bind any click events
		this.allowChange = true; // flag: is this unnecessary? prevents double ajax request
		this.currPage = null; // URL of page to compare against when navigating
		this.tempDom = null; // fake version of the shadow dom. currently a jQuery element.
		this.currRequest = null;
		this.aborter = null;
		this.selectors = [
			// attempt to make ajax sections dynamic. TODO: standardize naming
			{
				selector: "header",
				behavior: "replace",
				bodyClass: null,
			},
			{
				selector: "#content",
				behavior: "replace",
				bodyClass: null,
				ani: true, // wraps ajax contents in a div for page in/out transitions
			},
			{
				selector: "#content_modal",
				behavior: "add",
				bodyClass: "has-modal",
				bodyClassIfExisting: "modal-internal", // in this case, if the modal is already open, add this class
				domAdd: '<div class="page-modal-wrap" id="content_modal"></div>',
			},
		];
		this.aniTimer = null;

		// rebind
		this.jsEvts = this.bindEvents();

		// check for back/forward button navigation
		window.onpopstate = function () {
			if (
				window.location.pathname !== appScope.currPage &&
				appScope.ajaxMode
			) {
				appScope.allowChange = true; // Prevent from tripping up aj nav
				appScope.ajLoad(window.location.pathname);
			}
		};

		this.initSwiperGalleries();
	},
	bindEvents() {
		let appScope = this;
		// let allLinks = document.querySelectorAll('a');
		// if(allLinks.length > 0){
		// 	for(var l = 0; l < allLinks.length; l++){
		// 		let linkSingle = allLinks[l];
		// 		linkSingle.addEventListener("click", function (e) {
		// 			console.log("click event");
		// 			if (appScope.ajaxMode && appScope.allowChange) {
		// 				let scopeThis = $(this);
		// 				if (e.metaKey || e.ctrlKey) {
		// 					return;
		// 				} else if (
		// 					(e.currentTarget && e.currentTarget.href &&
		// 						!e.currentTarget.href.startsWith("/") &&
		// 						!e.currentTarget.href.includes(
		// 							window.location.host
		// 						)) ||
		// 					(
		// 						e.currentTarget && e.currentTarget.href && e.currentTarget.href.includes("wp-admin")
		// 					)
		// 				) {
		// 					// Found external link. Move on.
		// 					return;
		// 				} else {
		// 					// Use AJAX to handle click event
		// 					e.preventDefault();
		// 					var targetURL = e.currentTarget.href;
		// 					if (window.location.pathname !== targetURL) {
		// 						scopeThis.allowChange = false; // Prevent from tripping up aj nav
		// 						appScope.ajLoad(targetURL);
		// 					}
		// 				}
		// 			} else {
		// 				// console.log(appScope.ajaxMode, appScope.allowChange);
		// 			}
		// 		}, { once: true });
		// 	}
		// }

		$(document)
			.off("click", "a")
			.on("click", "a", function (e) {
				if ($(this).hasClass("no-ajax")) {
					return;
				}
				if (appScope.ajaxMode && appScope.allowChange) {
					let scopeThis = $(this);
					if (e.metaKey || e.ctrlKey) {
						return;
						// link target is _blank, return
					} else if (
						e.currentTarget.attributes.target &&
						e.currentTarget.attributes.target.value === "_blank"
					) {
						return;
					} else if (
						(e.currentTarget.href &&
							!e.currentTarget.href.startsWith("/") &&
							!e.currentTarget.href.includes(
								window.location.host
							)) ||
						e.currentTarget.href.includes(
							"." + window.location.host
						) ||
						e.currentTarget.href.includes("wp-admin")
					) {
						// Found external link. Move on.
						return;
					} else {
						// Use AJAX to handle click event
						e.preventDefault();
						var targetURL = e.currentTarget.href;
						if (window.location.pathname !== targetURL) {
							scopeThis.allowChange = false; // Prevent from tripping up aj nav
							appScope.ajLoad(targetURL);
						}
					}
				} else {
					// console.log(appScope.ajaxMode, appScope.allowChange);
				}
			});

		$(".readmore-content").on("click", function () {
			$(this).addClass("read-on");
		});

		$(".show-more").on("click", function () {
			$(this)
				.closest(".limited-view")
				.find(".hidden")
				.removeClass("hidden");
			$(this).remove();
		});

		// Flag: callback events (scroll in view).
		// Feels like this shouldn't be in this file, but what's the best way to incorporate these types of dom scripts after ajax
		inView(".iv").on("enter", function (el) {
			el.classList.add("vis");
		});
		if (window.location.pathname.includes("/projects")) {
			$("body").addClass("section-projects");
		} else {
			$("body").removeClass("section-projects");
		}
		if (window.location.pathname.includes("/archives")) {
			$("body").addClass("section-archives");
		} else {
			$("body").removeClass("section-archives");
		}
		$(".material-cycle-wrap")
			.not(".pimg")
			.each(function () {
				var countSlides = $(this).find(".material-cycle-single").length;
				if (countSlides > 1) {
					var carouselTempHero = $(this).addClass("pimg").flickity({
						prevNextButtons: true,
						pageDots: false,
						cellSelector: ".material-cycle-single",
						setGallerySize: true,
						wrapAround: true,
						imagesLoaded: true,
					});
					// cycleGal.on('dragStart.flickity', () => cycleGal.addClass('slide-moving'));
					// cycleGal.on('settle.flickity', () => cycleGal.removeClass('slide-moving slide-change'));
					carouselTempHero.on("dragStart.flickity", () =>
						carouselTempHero
							.find(".material-cycle-single")
							.css("pointer-events", "none")
					);
					carouselTempHero.on("dragEnd.flickity", () =>
						carouselTempHero
							.find(".material-cycle-single")
							.css("pointer-events", "all")
					);
				}
			});
		setTimeout(function () {
			window.dispatchEvent(new Event("resize"));
		}, 200);
		setTimeout(function () {
			window.dispatchEvent(new Event("resize"));
		}, 1000);
		setTimeout(function () {
			window.dispatchEvent(new Event("resize"));
		}, 2000);
		this.initSwiperGalleries();
		$(".chips-carousel-cycle-wrap")
			.not(".pimg")
			.each(function () {
				var countSlides = $(this).find(
					".chips-carousel-cycle-single"
				).length;
				if (countSlides > 1) {
					var optWrap = false;
					if ($(this).hasClass("carousel-wrap")) {
						optWrap = true;
					}
					var optControls = false;
					if ($(this).hasClass("carousel-controls")) {
						optControls = true;
					}
					var optDots = false;
					if ($(this).hasClass("carousel-dots")) {
						optDots = true;
					}

					var carouselTempHero = $(this).addClass("pimg").flickity({
						prevNextButtons: optControls,
						pageDots: optDots,
						cellSelector: ".chips-carousel-cycle-single",
						setGallerySize: true,
						wrapAround: optWrap,
					});
					// cycleGal.on('dragStart.flickity', () => cycleGal.addClass('slide-moving'));
					// cycleGal.on('settle.flickity', () => cycleGal.removeClass('slide-moving slide-change'));
					carouselTempHero.on("dragStart.flickity", () =>
						carouselTempHero
							.find(".chips-carousel-cycle-single")
							.css("pointer-events", "none")
					);
					carouselTempHero.on("dragEnd.flickity", () =>
						carouselTempHero
							.find(".chips-carousel-cycle-single")
							.css("pointer-events", "all")
					);
				}
			});

		$(".signup-form-toggle")
			.not(".ml-init")
			.each(function () {
				$(this).addClass("ml-init");
				$(this).on("click", function (e) {
					e.preventDefault();
					$("#mc_embed_signup").addClass("form-on");
					$("#mce-EMAIL").focus();
					return false;
				});
			});

		$(".material-audio .audio-play")
			.not(".hwi-init")
			.each(function () {
				$(this).addClass("hwi-init");
				$(this).on("click", function (e) {
					e.preventDefault();
					$(this).closest(".material-audio").addClass("audio-on");
					$(this).closest(".material-audio").find("audio")[0].play();
					return false;
				});
			});

		$(".page-modal-wrap").scrollTop(0);
		setTimeout(function () {
			$(".page-modal-wrap").scrollTop(0);
		}, 50);

		$(".menu-toggle").on("click", function () {
			appScope.menuToggle();
		});
	},
	ajLoad(targetURL) {
		let appScope = this;
		// console.log(targetURL);
		// const controller = new AbortController();
		// controller.abort();
		// if (this.currRequest !== null) {
		// 	console.log("canceling a request!");
		// 	console.log(this.currRequest);
		// 	appScope.currRequest.cancel();
		// }
		this.aborter = new AbortController();
		const signal = appScope.aborter.signal;
		this.currRequest = fetch(targetURL, { signal })
			.then(function (response) {
				// appScope.currRequest = null;
				appScope.aborter = null;
				if (response.status !== 200) {
					console.log(
						"Fetch failed. Response status: " + response.status
					);
					return;
				}
				appScope.currPage = targetURL;
				response.text().then(function (bodyText) {
					appScope.updateMarkup(bodyText);
				});
			})
			.catch(function (err) {
				console.log("Fetch failed. Error status: ", err);
			});

		this.initSwiperGalleries();
	},
	updateMarkup(pageHTML) {
		$("body").removeClass("menu-on");
		$("body").removeClass("initial-bg");
		$("html,body").scrollTop(0);
		let appScope = this;
		this.jsEvts = null; // flag: attempt to unbind events
		this.tempDom = $("<div />").html(
			'<div id="tempDom">' + pageHTML + "</div>"
		); // jQuery "cheap" version of the shadow-dom

		let pageTitle = this.tempDom.find("title").html();
		if (pageTitle && pageTitle.length > 3) {
			// console.log(pageTitle);
			pageTitle = pageTitle.replace("&amp;", "&");
			document.title = pageTitle; // updated page title
		}

		if (appScope.currPage === window.location.pathname) {
			// this happens after back/forward button navigation
			window.history.replaceState(
				appScope.currPage,
				pageTitle,
				appScope.currPage
			);
		} else {
			// standard navigation, update the URL
			window.history.pushState(
				appScope.currPage,
				pageTitle,
				appScope.currPage
			);
		}

		if (appScope.selectors.length > 0) {
			for (var s = 0; s < appScope.selectors.length; s++) {
				let selectorSingle = appScope.selectors[s];
				let selectorText = this.tempDom
					.find(selectorSingle.selector)
					.html();
				if (selectorText && selectorText.length > 4) {
					if (selectorSingle.behavior === "add") {
						if (!$(selectorSingle.selector).length) {
							$("body").append(selectorSingle.domAdd);
						}
					}
					if (
						selectorSingle.behavior === "replace" ||
						selectorSingle.behavior === "add"
					) {
						let leaveHTML = $(selectorSingle.selector).html();
						if (selectorSingle.ani) {
							if (leaveHTML !== selectorText) {
								clearTimeout(appScope.aniTimer);
								if (
									$(".ani-contents").hasClass("ani-contents")
								) {
									$(".ani-contents").addClass("ani-leaving");
									$(selectorSingle.selector).append(
										'<div class="ani-contents ani-enter">' +
											selectorText +
											"</div>"
									);
								} else {
									if (leaveHTML !== selectorText) {
										$(selectorSingle.selector).html(
											'<div class="ani-contents ani-leaving">' +
												leaveHTML +
												'</div><div class="ani-contents ani-enter">' +
												selectorText +
												"</div>"
										);
									}
								}
								appScope.aniTimer = setTimeout(function () {
									$(".ani-leaving").remove();
									$(".ani-enter").removeClass("ani-enter");
									// if (!$("body").hasClass("has-modal")) {
									// 	$("html,body").scrollTop(0);
									// }
								}, 350);
								// if (!$("body").hasClass("has-modal")) {

								// }
							} else {
								console.log(
									"Skip adding HTML, because it's already there"
								);
							}
						} else {
							$(selectorSingle.selector).html(selectorText);
						}
					}

					if (selectorSingle.bodyClass) {
						if (selectorSingle.bodyClassIfExisting) {
							if ($("body").hasClass(selectorSingle.bodyClass)) {
								$("body").addClass(
									selectorSingle.bodyClassIfExisting
								);
							}
						}
						$("body").addClass(selectorSingle.bodyClass);
					}
				} else {
					if (selectorSingle.bodyClass) {
						$("body").removeClass(selectorSingle.bodyClass);
					}
					if (selectorSingle.bodyClassIfExisting) {
						$("body").removeClass(
							selectorSingle.bodyClassIfExisting
						);
					}
				}
			}
		}

		setTimeout(function () {
			appScope.jsEvts = appScope.bindEvents(); // rebind events
		});

		gtag("event", "page_view", {
			page_title: pageTitle,
			page_location: window.location.href,
			page_path: window.location.pathname,
		});
	},
	menuToggle: function () {
		const homeEl = document.querySelector("body");
		if (!homeEl.classList || !homeEl.classList.contains("menu-on")) {
			if (homeEl.classList) {
				homeEl.classList.add("menu-on");
			}
		} else {
			if (homeEl.classList) {
				homeEl.classList.remove("menu-on");
			}
		}
	},

	initSwiperGalleries() {
		const swiperEls = document.querySelectorAll(".carousel-parent");
		if (swiperEls.length <= 0) {
			return;
		}
		swiperEls.forEach((el) => {
			if (el && el.classList.contains("swiper-container-initialized")) {
				// nothing
			} else {
				el.classList.add("swiper-container-initialized");
				const swiper = new swiperSlideshow({ $el: el });
			}
		});
	},
};

export default CHIPSAJ;
